export enum EMAIL_AUTOCOMPLETE_ACTION_TYPES {
  CHANGE_TEXT_INPUT = 'CHANGE_TEXT_INPUT',
  OPEN_DROPDOWN = 'OPEN_DROPDOWN',
  CLOSE_DROPDOWN = 'CLOSE_DROPDOWN',
  ARROW_NAVIGATION = 'ARROW_NAVIGATION',
  CLEAR_INPUT = 'CLEAR_INPUT',
  ON_SELECT = 'ON_SELECT',
}
